import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    previewContainer: {
      padding: '0',
    },
    previewList: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    previewListItem: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: 230,
      marginTop: 10,
      borderRadius: 5,
      boxShadow: theme.shadows[1],
    },
    maxItens: {
      marginBottom: '20px',
    },
    quantItens: {
      marginTop: '20px',
    },
    addButtonContainer: {
      width: '100%',
      backgroundColor: 'white',
      borderRadius: 8,
      padding: 25,
      marginBottom: 15,
      flexDirection: 'column',
    },
    previewItem: {
      width: '100%  ',
      overflow: 'hidden',
      padding: '10px 0',
      display: 'flex',
      flexDirection: 'row',
    },
    preview: {
      width: 200,
      height: 'auto',
      objectFit: 'cover',
      boxShadow: theme.shadows[2],
      borderRadius: 5,
      marginRight: 20,
    },
    imgDescription: {
      width: '100%',
    },
    root: {
      position: 'relative',
      padding: 30,
      maxWidth: '85%',
      [theme.breakpoints.down('sm')]: {
        padding: '30px 10px 80px 10px',
      },
    },
    formGroup: {
      marginTop: 10,
    },
    textField: {
      width: '100%',
      marginTop: 15,
      minWidth: 220,
      backgroundColor: '#f1f3f2',
    },
    accordionContainer: {
      backgroundColor: '#eaeaea',
    },
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      width: 'inherit',
      maxWidth: 250,
      marginLeft: 10,
      [theme.breakpoints.up('md')]: {
        top: '160px',
      },
      [theme.breakpoints.down('sm')]: {
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: 500,
        marginBottom: 15,
        marginLeft: 0,
      },
    },
    buttons: {
      minWidth: 210,
      margin: 5,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      [theme.breakpoints.down('xs')]: {
        textTransform: 'none',
        minWidth: 300,
        margin: 3,
      },
    },
    buttonWrapper: {
      width: '100%',
      position: 'relative',
    },
    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  }),
);
